import React, { useState, useEffect } from "react";
import { getAllMPMetalSheetTables } from '../../services/tables/MPMetalSheetTableService';
import MPMetalSheetTable from "../../components/tecnical-sheets/MPMetalSheetTable";
import { Backdrop, CircularProgress, Box } from "@mui/material";
import Notify from "../../components/global/Notify";

const MPMetalSheetTablePage = () => {

    const page = 0;
    const rowsPerPage = 20;
    const [searchString, setSearchString] = useState('');
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = await getAllMPMetalSheetTables(page, rowsPerPage, searchString);
                setRows(res['content']);
            } catch (error) {
                if (error?.silent) {
                    return;
                }
                notify(error.message, false);
            } finally {
                setLoading(false);
            }
        })();
    }, [page, rowsPerPage, searchString]);

    const notify = (message, isSucessMessage) => {
        if (isSucessMessage) {
            Notify.success(message);
        } else {
            Notify.error(message);
        }
    };

    const onSearchChange = (search) => {
        setSearchString(search);
    }

    return (
        <>
            <Box sx={{ position: "relative", width: "100%", boxShadow: 4 }}>
                <MPMetalSheetTable
                    rows={rows}
                    onSearchChange={onSearchChange}
                />

                <Backdrop
                    open={loading}
                    sx={{
                        position: "absolute",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        color: "#04642c",
                        zIndex: 1,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress color="inherit" size={40} />
                </Backdrop>
            </Box>
        </>
    );
}
export default MPMetalSheetTablePage;